// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2TKR6","bigColWidth":"Table_bigColWidth__30B3U","biggerColWidth":"Table_biggerColWidth__Qwn0_","row":"Table_row__pIPjL","col":"Table_col__1e3hK"};